/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const NoteRegularV6 = (props) => (
  <Icon {...props} name="Note Regular V6">
    <path d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.669a2 2 0 0 0 1.414-.586l2.332-2.333c.376-.375.585-.885.585-1.413V2.999c0-1.1-.9-2-2-2zm.5 9h-2.472a1 1 0 0 0-1 1v2.496H3a.5.5 0 0 1-.5-.5L2.501 3a.5.5 0 0 1 .5-.5h9.972a.5.5 0 0 1 .5.5v7h.028z" />
  </Icon>
);

export default NoteRegularV6;
